var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._g(_vm._b({attrs:{"headers":_vm.headers,"item-key":"_id"},scopedSlots:_vm._u([{key:"item.annualFee",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatPercentage(item.annualFee))+" ")]}},{key:"item.operationDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.operationDate))+" ")]}},{key:"item.loanDueDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.loanDueDate))+" ")]}},{key:"item.quantity",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'error--text': item.quantity < 0 }},[_vm._v(" "+_vm._s(_vm.formatNumber(item.quantity))+" ")])]}},{key:"item.refPrice",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'error--text': item.refPrice < 0 }},[_vm._v(" "+_vm._s(_vm.formatCurrency(item.refPrice))+" ")])]}},{key:"item.accruedFees",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'error--text': item.accruedFees < 0 }},[_vm._v(" "+_vm._s(_vm.formatCurrency(item.accruedFees))+" ")])]}},{key:"item.percValue",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'error--text': item.percValue < 0 }},[_vm._v(" "+_vm._s(_vm.formatPercentage(item.percValue))+" ")])]}}])},'v-data-table',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }